import { catalogStatusLabel } from "./catalogApprovalMessages";
import "./CatalogCreationApprovals.css";

const types = { family: "Family", subfamily: "Subfamily", category: "Category", subcategory: "Subcategory", item: "Item", supplier: "Supplier" };

function ChainGroup({ label, rows, hierarchy, t }) {
  return <span role="list" aria-label={label} className="catalogApproval__chainGroup">
    <strong className="catalogApproval__chainLabel">{label}</strong>
    {rows.map((row, index) => <span key={row.id} role="listitem" className="catalogApproval__chainEntry">
      {hierarchy && index > 0 && <span aria-hidden="true" className="catalogApproval__chainArrow">→</span>}
      <span className="catalogApproval__chainRecord">
        <span>{t(types[row.entity_type] || "Catalog record")} · <strong>{row.name || row.code || `#${row.id}`}</strong></span>
        <small>{t(row.can_approve ? "Your signature" : row.approval_mode === "direct" ? "Automatic publication" : "No signature required from you")}</small>
      </span>
    </span>)}
  </span>;
}

export default function CatalogApprovalSubtitle({ request, t }) {
  const type = (types[request.entity_type] || "Catalog record").toLowerCase();
  const operation = request.operation === "merge" ? t("Supplier merge")
    : t(request.operation === "update" ? `Changes to ${type}` : `New ${type}`);
  const ancestors = request.approval_chain || [];
  const suppliers = ancestors.filter(row => row.entity_type === "supplier");
  const hierarchy = ancestors.filter(row => row.entity_type !== "supplier");
  return <span className="catalogApproval__subject">
    <span><strong className="catalogApproval__subjectType">{operation}</strong>
      <span className="catalogApproval__subjectMeta">#{request.id} · {catalogStatusLabel(request.status, t)}</span>
    </span>
    {ancestors.length > 0 && <span className="catalogApproval__chainSummary">
      <ChainGroup label={t("Approval chain")} hierarchy t={t} rows={[...hierarchy, {
        ...request, name: request.payload?.name, code: request.payload?.code, approval_mode: request.approver_ids?.length === 0 ? "direct" : "approval",
      }]} />
      {suppliers.length > 0 && <ChainGroup label={t("Linked suppliers")} rows={suppliers} t={t} />}
    </span>}
  </span>;
}
